import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './modules/auth';
import snackbar from './modules/snackbar';
import menu from './modules/menu';
Vue.use(Vuex);
const store = new Vuex.Store({
    modules: {
        auth,
        snackbar,
        menu
    },
    getters: {
        accessToken(state) {
            return state.auth.accessToken;
        },
        isAuth(_, getters) {
            return getters['auth/isAuth'];
        }
    },
    plugins: [
        createPersistedState({
            paths: ['auth']
        })
    ]
});
export default store;
export const useStore = () => store;
